import React, { Fragment, useMemo } from 'react'
import { getKeyString } from '@corratech/pylot-utils'

type GridPageInput<T> = {
    items: T[]
    ProductTile: React.ComponentType<T>
    getMarketing: (idx: number) => JSX.Element | null
    startingIndex: number
    hideMarketingBlock?: boolean
}

export const GridPage = ({
    items,
    ProductTile,
    getMarketing,
    startingIndex,
    hideMarketingBlock = false
}: GridPageInput<any>): JSX.Element => {
    const keyString = useMemo(() => getKeyString(items), [items])
    const itemElements = useMemo(
        () =>
            items.map((item, idx) => (
                // This must be a fragment, not a div
                <Fragment key={item.sku || idx}>
                    <ProductTile product={item} />
                    {!hideMarketingBlock && getMarketing(startingIndex + idx)}
                </Fragment>
            )),
        [
            keyString,
            ProductTile,
            getMarketing,
            startingIndex,
            hideMarketingBlock
        ]
    )
    return <>{itemElements}</>
}
